import template from './multi-mask-input.html';

const multiMaskInputDirective = /* @ngInject */ (/** @type {any} */ COMMON_OPTIONS) => ({
	scope: {
		component: '=',
		property: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	link: (/** @type {any} */ scope) => {
		if (!scope.property) {
			return;
		}
		scope.label = (COMMON_OPTIONS[scope.property] && COMMON_OPTIONS[scope.property].label) || '';
		scope.tooltip = (COMMON_OPTIONS[scope.property] && COMMON_OPTIONS[scope.property].tooltip) || '';
		if (scope.property) {
			scope.component[scope.property] = {};
		}
		scope.$watch('mask', (/** @type {any} */ newMask) => {
			scope.component[scope.property].maskName = newMask.label || undefined;
			scope.component.inputMask = newMask.mask || undefined;
		});

		scope.$watch('value', (/** @type {any} */ newValue) => {
			scope.component[scope.property].value = newValue;
		});
	},
});

export default multiMaskInputDirective;
